import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BrowserNotSupportedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"browser_not_supported"}/>
}
